"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const separatorStyles = (0, class_variance_authority_1.cva)("relative", {
    variants: {
        orientation: {
            horizontal: "h-px w-full",
            vertical: "w-px h-4",
        },
        color: {
            gray: "bg-grey300",
            blue: "bg-blue-900",
            red: "bg-red-500",
        },
    },
    defaultVariants: {
        orientation: "horizontal",
    },
});
const Separator = ({ orientation = "horizontal", color, className, ...props }) => {
    const isCustomBg = className?.includes("bg-") || className?.includes("bg[");
    return (react_1.default.createElement("div", { role: "separator", className: (0, clsx_1.default)(separatorStyles({
            orientation,
            color: !isCustomBg ? color ?? "gray" : undefined,
        }), !color && !isCustomBg && "bg-black", // fallback to black if no color & no custom class
        className), ...props }));
};
exports.Separator = Separator;
